import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import images from '../../assets/images';
import {
  getPricingTracks,
  chargePaymentOffSession,
  createPaymentIntent,
  getCustomerCardDetails
} from '../../services/pricingService';

import Loading from '../../components/Loading/Loading';
import { setSelectedBuyTracks, setSelectedPlan, setPricingTrack } from '../../actions/pricingActions';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { setErrorMessage, clearResponseMessage } from '../../actions/messageActions';
//import { initWebflowReady, getUrlParam } from '../../global/Helpers';
import { getUrlParam } from '../../global/Helpers';

import PaymentModal from './PaymentModal';
import { REACT_APP_STRIPE_PUBLIC_KEY } from '../../global/Environment';
//import pricingPlans from '../../data/pricingPlans';
import { trackActivity } from '../../services/analyticsService';
import { logout } from '../../services/authService';

import { API_VERSION } from '../../global/constant';

import ProfileDropDown from '../../components/ProfileDropDown/ProfileDropDown';

import { getPlans as getPricingPlans} from '../../services/siteDataService';


const stripe = loadStripe(REACT_APP_STRIPE_PUBLIC_KEY);

class PricingTrack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPaymentModal: false
    };
  }

  componentDidMount() {
    let source = getUrlParam(this.props.location.search, 'planId');
    trackActivity('navigation: pricing track', source && { source: source });
    this.LoadData();
    this.props.clearResponseMessage();
  }

  componentWillUnmount() {
    this.props.clearResponseMessage();
  }

  LoadData = async () => {

    const plans = await getPricingPlans();
	this.setState({pricingPlans: plans});

    this.props.setPricingTrack();
    let planId = getUrlParam(this.props.location.search, 'planId');
    const { selectedPlan } = this.props.pricing;
    if (!selectedPlan.id) this.setSelectedPlan(planId);
    this.props.setSelectedBuyTracks([]);
    const isAlltrack = selectedPlan.id === 'unlimited_tracks' || planId === 'unlimited_tracks';


   // let	apiVersion = (window.location.pathname ==='/pricing-track-v2') ? 'v2' : 'v1';

	// getPricingTracks knows which api to use (spreadsheet or database)
    // await this.props.getPricingTracks(isAlltrack, planId, apiVersion);

    await this.props.getPricingTracks(isAlltrack, planId, API_VERSION);

    //initWebflowReady();
  };

  setSelectedPlan = (planId) => {
    if (!planId) return;

    //alert(JSON.stringify(this.props.pricingPlans))

    const { pricingPlans } = this.state;

    // AW new prevent crash if user reloads
    // pricing-track?planId=individual_track
    if(!  pricingPlans) {
    	this.props.history.push('/pricing');
    	return;
    }

    const selectedPlan = pricingPlans.find((x) => x.id === planId);
    this.props.setSelectedPlan(selectedPlan);
  };

  addToCart = (item, index) => {
    let selectedBuyTracks = this.props.pricing.selectedBuyTracks;
    selectedBuyTracks.push({ id: index, ...item });
    trackActivity('pricing - track: add to cart', {
      track: String(item.track).toLowerCase(),
      date: item.formatted_date
    });
    this.props.setSelectedBuyTracks(selectedBuyTracks);
  };

  removeFromCart = (item, id) => {
    let selectedBuyTracks = this.props.pricing.selectedBuyTracks;
    selectedBuyTracks = selectedBuyTracks.filter((x) => x.id !== id);
    trackActivity('pricing - track: remove from cart', {
      track: String(item.track).toLowerCase(),
      date: item.formatted_date
    });
    this.props.setSelectedBuyTracks(selectedBuyTracks);
  };

  onCheckoutClick = () => {
    this.onOpenPaymentModal();
  };

  onOpenPaymentModal = () => {
    this.props.clearResponseMessage();
    this.setState({ isPaymentModal: true });
  };

  onClosePaymentModal = () => {
    this.setState({ isPaymentModal: false });
  };



  renderErrors() {
    const { resError } = this.props.message;
    if (resError) {
      return <div className='alert-message'>{resError}</div>;
    }
  }

  render() {
    const { user } = this.props.auth;
    const { loading, pricingTrack, selectedBuyTracks, selectedPlan } = this.props.pricing;
    const { isPaymentModal } = this.state;

    const amount = Number(selectedPlan.price) * Number(selectedBuyTracks.length);

    if (loading && !pricingTrack) return <Loading />;
    return (
      <div className='login-body'>
        <div className='navbar pricing w-nav'>
          <div className='container w-container'>
            <div className='nav-inner-home pricing'>
              <a className='brand-logo-home w-nav-brand'>
                <img src={images['logo'].default} alt='' />
              </a>
              {/* <div className='nav-btn'>
                <button type='button' className='btn-primary' onClick={this.navToDashboard}>
                  dashboard
                </button>
              </div> */}


                <ProfileDropDown
                    user={user}
                    propsParent={this.props}
                />



              {/* <nav className='nav-menu home w-nav-menu'>
                <div className='nav-btn'>
                  <a className='btn-primary' href='/dashboard'>
                    dashboard
                  </a>
                </div>
              </nav> */}
              <div className='menu-button w-nav-button'>
                <div className='icon w-icon-nav-menu'></div>
                <div className='top-line'></div>
                <div className='middle-line'></div>
                <div className='bottom-line'></div>
              </div>
            </div>
          </div>
        </div>
        <div className='pricing-content normal'>
          <div className='container w-container'>
            <div className='pricing-head-block'>
              <h4 className='pricing-title'>Select Your Track :</h4>
            </div>
            <div className='track-wrapper'>
              <div className='track-left'>
                <ul className='track-list w-list-unstyled'>
                  {pricingTrack && pricingTrack.length > 0 ? (
                    pricingTrack.map((item, index) => {
                      const isItemAdded = selectedBuyTracks && selectedBuyTracks.some((x) => x.id === index);
                      return (
                        <li className='track-item' key={String(index)}>
                          <div className='track-info'>
                            <h5 className='track-title'>{item.track}</h5>
                            <p className='race-text'></p>
                          </div>
                          <div className='track-time'>
                            <p className='race-text'>{item.formatted_date}</p>
                            <p className='time-text'></p>
                          </div>
                          {!isItemAdded ? (
                            <div
                              className='track-btn'
                              onClick={() => {
                                this.addToCart(item, index);
                              }}>
                              <button type='button' className='btn-cart w-button'>
                                Add to Cart
                              </button>
                            </div>
                          ) : (
                            <div
                              className='track-btn'
                              onClick={() => {
                                this.removeFromCart(item, index);
                              }}>
                              <button type='button' className='btn-cart remove w-button'>
                                Remove
                              </button>
                            </div>
                          )}
                        </li>
                      );
                    })
                  ) : (
                    <h5 className='amount-text'>New cards coming soon.</h5>
                  )}
                </ul>
              </div>
              <div className='track-right'>
                <div className='track-right-head'>
                  <h4 className='track-right-title'>Your Order :</h4>
                </div>
                <ul className='order-list w-list-unstyled'>
                  {selectedBuyTracks &&
                    selectedBuyTracks.length > 0 &&
                    selectedBuyTracks.map((item) => (
                      <li className='order-item' key={String(item.id)}>
                        <div className='track-info'>
                          <h5 className='track-title'>{item.track}</h5>
                          <p className='race-text'></p>
                        </div>
                        <div className='track-time'>
                          <p className='race-text'>{item.formatted_date}</p>
                          <p className='time-text'></p>
                        </div>
                      </li>
                    ))}
                </ul>
                <div className='order-item amount'>
                  <div className='amount-block'>
                    <h5 className='amount-text'>Total Amount :</h5>
                    <p className='amount-text num'>$ {amount}</p>
                  </div>
                  <button type='button' className='btn-square f-wth w-button' onClick={this.onCheckoutClick}>
                    Checkout
                  </button>
                </div>
              </div>
            </div>
            <div className='track-right mobile'>
              <div className='order-item normal'>
                <div className='amount-block'>
                  <h5 className='amount-text'>Total Amount :</h5>
                  <p className='amount-text num'>$ {amount}</p>
                </div>
                <button type='button' className='btn-square f-wth w-button' onClick={this.onCheckoutClick}>
                  Checkout
                </button>
              </div>
            </div>
          </div>
          {/* Modal */}

          {isPaymentModal && (
            <Elements stripe={stripe}>
              <PaymentModal
                selectedBuyTracks={selectedBuyTracks}
                selectedPlan={selectedPlan}
                amount={amount}
                loading={loading}
                {...this.props}
                onClosePaymentModal={this.onClosePaymentModal}
              />
            </Elements>
          )}
        </div>
        {this.renderErrors()}
      </div>
    );
  }
}

PricingTrack.propTypes = {
  message: PropTypes.object.isRequired,
  pricing: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  onboarding: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  message: state.message,
  pricing: state.pricing,
  auth: state.auth,
  onboarding: state.onboarding
});

export default connect(mapStateToProps, {
  getPricingTracks,
  setSelectedBuyTracks,
  setErrorMessage,
  setSelectedPlan,
  clearResponseMessage,
  createPaymentIntent,
  chargePaymentOffSession,
  getCustomerCardDetails,
  setPricingTrack,
  logout
})(PricingTrack);
